module.exports = __webpack_public_path__ + "media/images/crown-8c454d08b3a59e511eb194adea977a43.svg";